import Select from 'react-select';
import { Panel } from 'react-instantsearch-dom';
import React, { useEffect } from 'react';
import AdminValueContainer from '../../widgets/filters/react-select-custom-child-components/AdminValueContainer';
import CheckBoxOption from '../../widgets/filters/react-select-custom-child-components/checkbox-option';
import { DropdownIndicator } from '../../widgets/filters/react-select-custom-child-components/DropdownHelpers';
import { AttributesInterface } from '../../admin-dashboard-tables/interfaces';

interface Props {
  attribute: AttributesInterface,
}

const SimpleAttributeSelector: React.FC<Props> = ({
  attribute,
}) => {
  const {
    selectedValue,
    setSelectedValue,
    isMulti,
    placeholder,
    DisplayComponent,
    isSearchable,
    options,
    onChangeCallback,
  } = attribute;

  useEffect(() => {
    if (onChangeCallback) {
      onChangeCallback(selectedValue);
    }
  }, [selectedValue]);

  return (
    <Panel className="mr-3 mb-3">
      <Select
        isClearable
        isMulti={isMulti}
        aria-label={placeholder}
        className="algolia-select btn btn-outline-light border-border-grey button-shadow text-dark-btn-txt align-items-center w-100"
        classNamePrefix="algolia-select"
        value={isMulti ? selectedValue : selectedValue && selectedValue[0]}
        newValueComponent={DisplayComponent}
        components={{
          ValueContainer: AdminValueContainer,
          Option: CheckBoxOption,
          IndicatorSeparator: () => null,
          DropdownIndicator,
        }}
        onChange={(value) => setSelectedValue && setSelectedValue(value)}
        isSearchable={isSearchable}
        options={options}
        placeholder={placeholder}
      />
    </Panel>
  );
};

export default SimpleAttributeSelector;
